<!-- DESKTOP VIEW -->
<span
  class="main"
  *ngIf="!isMobile && !minutes"
  [ngClass]="{ 'no-letter-spacing': isMobile }">
  <span
    class="numbers"
    [ngClass]="[
      flight_card ? 'flights_card_style' : '',
      img_card ? 'img_card_style' : ''
    ]"
    >{{ days$ | async }}</span
  >
  <span class="tiny">{{ text_days$ | async }} </span>

  <span
    class="numbers"
    [ngClass]="[
      flight_card ? 'flights_card_style' : '',
      img_card ? 'img_card_style' : ''
    ]"
    >{{ hours$ | async }}</span
  >
  <span class="tiny">{{ text_hours$ | async }} </span>

  <span
    class="numbers"
    [ngClass]="[
      flight_card ? 'flights_card_style' : '',
      img_card ? 'img_card_style' : ''
    ]"
    >{{ minutes$ | async }}</span
  >
  <span class="tiny">{{ text_minutes$ | async }} </span>

  <span
    class="numbers"
    [ngClass]="[
      flight_card ? 'flights_card_style' : '',
      img_card ? 'img_card_style' : ''
    ]">
    {{ seconds$ | async }}</span
  >
  <span class="tiny">{{ text_seconds$ | async }}</span>
</span>

<!-- DESKTOP SHORT VIEW -->
<span class="main" *ngIf="!isMobile && minutes">
  {{ minutes$ | async }}
  <span class="tiny">{{ text_minutes$ | async }} </span>
  {{ seconds$ | async }}
  <span class="tiny">{{ text_seconds$ | async }}</span>
</span>

<!-- MOBILE VIEW -->
<div *ngIf="isMobile" class="mobile-time-wrapper">
  <div class="time-row">
    <span class="mobile-number">{{ days$ | async }}</span
    >:<span class="mobile-number">{{ hours$ | async }}</span
    >:<span class="mobile-number">{{ minutes$ | async }}</span
    >:<span class="mobile-number">{{ seconds$ | async }}</span>
  </div>
</div>
